import React, { useState } from "react";
import { FaTimes } from "react-icons/fa";
import "./Gallery.css";
import { galleryImages } from "../config/gallery";

export interface GalleryImage {
  id: number;
  src: string;
  title: string;
  description: string;
}

const Gallery: React.FC = () => {
  const [selectedImage, setSelectedImage] = useState<GalleryImage | null>(null);

  const openLightbox = (image: GalleryImage): void => {
    setSelectedImage(image);
    document.body.style.overflow = "hidden";
  };

  const closeLightbox = (): void => {
    setSelectedImage(null);
    document.body.style.overflow = "auto";
  };

  return (
    <section className="gallery">
      <div className="gallery-container">
        <h2>Unsere Referenzprojekte</h2>
        <div className="gallery-grid">
          {galleryImages.map((image) => (
            <div
              key={image.id}
              className="gallery-item"
              onClick={() => openLightbox(image)}
            >
              <img src={image.src} alt={image.title} />
              <div className="gallery-item-overlay">
                <h3>{image.title}</h3>
                <p>{image.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {selectedImage && (
        <div className="lightbox" onClick={closeLightbox}>
          <button className="lightbox-close" onClick={closeLightbox}>
            <FaTimes />
          </button>
          <div
            className="lightbox-content"
            onClick={(e) => e.stopPropagation()}
          >
            <img src={selectedImage.src} alt={selectedImage.title} />
            <div className="lightbox-info">
              <h3>{selectedImage.title}</h3>
              <p>{selectedImage.description}</p>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Gallery;
